import * as React from 'react';
import { MenuItemImage } from 'moduleBase/components/menu/MenuItemImage';
import { MenuItemBadge } from 'moduleBase/components/menu/MenuItemBadge';
import { When } from 'react-if';
import { Badge } from 'ui/badge/Badge';
import { Variant } from '@collaborator/npm_modules/dist/css/variant';

var MenuItemContent = function MenuItemContent(_ref) {
  var label = _ref.label,
      badge = _ref.badge,
      icon = _ref.icon,
      image = _ref.image,
      _ref$imageWidth = _ref.imageWidth,
      imageWidth = _ref$imageWidth === void 0 ? null : _ref$imageWidth,
      _ref$imageClassName = _ref.imageClassName,
      imageClassName = _ref$imageClassName === void 0 ? 'mr-10p' : _ref$imageClassName,
      notify = _ref.notify;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItemImage, {
    icon: icon,
    image: image,
    imageWidth: imageWidth,
    imageClassName: imageClassName
  }), label, /*#__PURE__*/React.createElement(When, {
    condition: notify
  }, /*#__PURE__*/React.createElement(Badge, {
    variant: Variant.warning,
    pill: true,
    additionalClassName: "text-white ml-1"
  }, notify)), /*#__PURE__*/React.createElement(MenuItemBadge, {
    badge: badge
  }));
};

export { MenuItemContent };